import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { getBackgroundColor } from '@magalu/stereo-ui-styles';
import styled from 'styled-components';
export var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), function (props) {
  return getBackgroundColor('lighter')(props);
});